import React, { useState, useEffect } from "react";
// Import components
import Header from "./Header";
import Footer from "./Footer";
import LayeredNavigation from "./LayeredNavigation/LayeredNavigation";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { getPartnerDetails } from "../slices/partner/action";
import { useSelector, useDispatch } from "react-redux";
import { getRewardTypes } from "../slices/reward/action";

const Layouts = ({ children }) => {
  const [theme, setTheme] = useState("light");

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  const dispatch = useDispatch();
  const { partnerDetails } = useSelector((state) => state.partner);
  const { rewardTypeRes } = useSelector((state) => state.reward);

  useEffect(() => {
    if (!partnerDetails) {
      getPartnerDetailsFunc();
    }

    if (rewardTypeRes?.length === 0) {
      getRewardTypesFunc();
    }
  }, []);

  const getPartnerDetailsFunc = async () => {
    try {
      await getPartnerDetails({}, dispatch);
    } catch (e) {
      console.log(e);
    }
  };

  const getRewardTypesFunc = async () => {
    try {
      await getRewardTypes({}, dispatch);
    } catch (e) {
      console.log(e);
    }
  };

  // const toggleLayout = () => {
  //   setIsVerticalLayout((prevLayout) => !prevLayout);
  // };

  useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", theme);
  }, [theme]);

  return (
    <React.Fragment>
      <div id="layout-wrapper" className="min-vh-100 d-flex flex-column">
        <Header theme={theme} />

        <Container>
          <Card className="rounded-3">
            <CardBody className="p-0">
              <div className="d-grid main-content">
                <LayeredNavigation />
                {children}
              </div>
            </CardBody>
          </Card>
        </Container>

        <Footer theme={theme} toggleTheme={toggleTheme} />
      </div>
    </React.Fragment>
  );
};

export default Layouts;
